import type { ReactNode, FC } from 'react';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import ListItemCheckbox from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemCheckbox';
import ListItemDiv from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemDiv';
import DeviationThumb from '../../../StudioDeviationList/_partials/DeviationThumb';
import DeviationInfo from '../../../StudioDeviationList/_partials/DeviationInfo';
import DeviationTitle from '../../../StudioDeviationList/_partials/DeviationTitle';
import DeviationActions from '../../../tableActions/DeviationActions';

import s from './ProductListItem.scss';

export interface Props {
  deviation: PapiDeviation;
  offset: number;
  subLabel?: ReactNode;
  bottomSlot?: ReactNode;
  thumbSlot?: ReactNode;
  isSelectable?: boolean;
  isUnlisted?: boolean;
  isSelected?: boolean;
  isInSelectMode?: boolean;
  onSelect?: any;
}

const ProductListItem: FC<Props> = ({
  deviation,
  offset,
  subLabel,
  bottomSlot,
  thumbSlot,
  isSelectable,
  isUnlisted,
  isSelected,
  isInSelectMode,
  onSelect,
}) => {
  const commonProps = {
    prefix: thumbSlot ?? <DeviationThumb deviation={deviation} />,
    label: <DeviationTitle deviation={deviation} showSaleIndicators={false} />,
    subLabel: (
      <div className={s['sublabel']}>
        {subLabel || <DeviationInfo deviation={deviation} />}
      </div>
    ),
    suffix: isInSelectMode ? null : (
      <DeviationActions
        deviation={deviation}
        offset={offset}
        contextMenuProps={{ wrapperClassName: s['context-menu'] }}
        onlyContextMenu
      />
    ),
    bottomSlot: bottomSlot ? (
      <div className={s['bottom-slot']}>{bottomSlot}</div>
    ) : null,
  };

  if (!isSelectable) {
    return <ListItemDiv className={s['root']} {...commonProps} />;
  }
  return (
    <ListItemCheckbox
      {...commonProps}
      className={cn(s['root'], s['selectable'])}
      inputClassName={s['checkbox']}
      checked={isSelected}
      onChange={checked => onSelect(offset, checked)}
    />
  );
};
ProductListItem.displayName = 'ProductListItem';

export default ProductListItem;
